/** Spec 084 — yellow banner when the nightly evaluator raised at least one alert in the last 7 days. */
export default function AlertBanner({ count, onOpen }: { count: number; onOpen: () => void }) {
  if (count <= 0) return null;
  return (
    <div className="mkt-alert-banner" role="status" data-testid="alert-banner">
      <svg className="mkt-alert-banner__icon" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M10 2.5l8 14H2l8-14z" fill="none" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M10 8v4M10 14.2v.3" fill="none" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      <span className="mkt-alert-banner__text">
        <b>{count === 1 ? '1 marketing alert' : `${count} marketing alerts`}</b> in the last 7 days.
      </span>
      <button type="button" className="admin-btn admin-btn-outline admin-btn-sm" onClick={onOpen} data-testid="alert-banner-open">
        See alerts
      </button>
    </div>
  );
}
